hrd.charts.GaugeChart = hrd.charts.AbstractChart.extend({
	init: function(options, dynamicOptions, customChartOptions) {
		this.staticChartOptions = $.extend(true, this._specificChartOptions(), customChartOptions || {});
		this._super(options, dynamicOptions, {useXs: false});
	},
	doChartOptions: function(){
		return this.staticChartOptions;
	},
	_adaptSpecificChart: function(staticOptions, dynamicOptions){
		staticOptions.gauge = {
			show: dynamicOptions.showLabels,
			expand: dynamicOptions.expand,
			min:  dynamicOptions.min,
			max:  dynamicOptions.max,
			label : {
				show: dynamicOptions.showLabels,
			}
		};
		if(dynamicOptions.width){
			staticOptions.gauge.width = dynamicOptions.width;
		}
		if(dynamicOptions.formatPattern){
			staticOptions.gauge.label.format = function(v, r){
				return d3locale.format(this.pattern)(this.useRatio ? r : v);
			}.bind({pattern: dynamicOptions.formatPattern, useRatio: dynamicOptions.useRatio});
			staticOptions.gauge.label.extents = function(v, r){
				return d3locale.format(this.pattern)(this.useRatio ? r : v);
			}.bind({pattern: dynamicOptions.formatPattern, useRatio: dynamicOptions.useRatio});

		}
	},
	/* @Deprecated */
	___specificChartOptions: function(){
		return {
			color: {
				_pattern: ['#FF0000', '#F97600', '#F6C600', '#60B044'], // the three color levels for the percentage values.
				_threshold: {
					unit: 'value', // percentage is default
//					max: 200, // 100 is default
					_values: [30, 60, 90, 100]
				}
			},
		};
	},
	_dataToColumns: function(staticOptions, dynamicOptions){
		var data = dynamicOptions.data;
		var columns = [];
		var colors = {};
		if(data && $.isArray(data.series) && data.series.length > 0){
			$.each(data.series, function(i, serie){
				var firstItem = serie.items[0];
				columns.push([firstItem.x, firstItem.y]);
				if(serie.serieColor){
					colors[firstItem.x] = serie.serieColor;
				}
			});
		}
		staticOptions.data.colors = colors;
		staticOptions.data.columns = columns;
	}
});